var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 table-container"},[_c('Table',{attrs:{"headers":_vm.headers,"cols":_vm.cols,"data":_vm.contacts,"checkbox":false,"notselect":true,"model":_vm.contacts}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }